'use client';

import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { formatNumber } from '@/lib/number';
import { TableStatsHistogram } from '@/lib/types/TableStatsHistogram';
import { NotAvailable } from '../NotAvailable';
import { HistogramData, transformData } from './helper';
type HistogramType = 'tiny' | 'default';
interface HistogramProps {
  data?: TableStatsHistogram;
  type?: HistogramType;
}

// const HISTOGRAM_TEST_DATA_MAX = 500000;
const HISTOGRAM_BAR_RADIUS: [number, number, number, number] = [0, 0, 0, 0];
const HISTOGRAM_TINY_CHART_HEIGHT = 40;
const HISTOGRAM_TINY_CHART_WIDTH = 90;
export const hasHistogramData = (data?: TableStatsHistogram) => data && (data?.[0]?.length ?? 0) > 0 && (data?.[1]?.length ?? 0) > 0;
export function Histogram({
  data,
  type = 'default'
}: HistogramProps) {
  if (!hasHistogramData(data)) {
    return <div className="mb-5">
        <NotAvailable />
      </div>;
  }
  const transformedData = transformData(data);
  if (type === 'tiny') {
    return <ResponsiveContainer width="100%" height={HISTOGRAM_TINY_CHART_HEIGHT}>
        <BarChart width={HISTOGRAM_TINY_CHART_WIDTH} height={HISTOGRAM_TINY_CHART_HEIGHT} data={transformedData}>
          <Bar dataKey="value" fill="currentColor" radius={HISTOGRAM_BAR_RADIUS} className="fill-primary" />
        </BarChart>
      </ResponsiveContainer>;
  }
  return <ResponsiveContainer width="100%" height={200}>
      <BarChart margin={{
      top: 10,
      left: 0,
      right: 0,
      bottom: 0
    }} data={transformedData}>
        <Tooltip content={({
        active,
        payload
      }) => {
        if (active && payload && payload.length) {
          const {
            name,
            value
          }: HistogramData = payload?.[0].payload;
          return <div className="shadow-md font-mono rounded-md border border-secondary-readable bg-white text-secondary-readable py-2 px-5">
                  <div className="flex flex-col">
                    <span className="text-sm">x: {formatNumber(name)}</span>
                    <span className="text-sm">y: {formatNumber(value)}</span>
                  </div>
                </div>;
        }
        return null;
      }} />
        <XAxis dataKey="name" stroke="#888888" fontFamily="var(--font-oxygen-mono)" fontSize={12} tickLine={true} axisLine={true} tickFormatter={(tick: number) => formatNumber(tick)} />
        <YAxis dataKey="value" stroke="#888888" fontFamily="var(--font-oxygen-mono)" fontSize={12} tickLine={true} axisLine={true} tickFormatter={(tick: number) => formatNumber(tick)} />
        <Bar dataKey="value" fill="currentColor" radius={HISTOGRAM_BAR_RADIUS} className="fill-primary" />
      </BarChart>
    </ResponsiveContainer>;
}